import {coreApi} from '~/services/core'

export const comingSupplier = {
  getAll: async () => coreApi.get(`suppler`),
  getById: async (id) => coreApi.get(`suppler?id=${id}`),
  create: async (data) => coreApi.post(`suppler`, data),
  update: async (data) => coreApi.put(`suppler`, data),
  paginate: async (offset) => coreApi.get(`suppler/${offset}`)
}